import React from 'react';
import { ScheduledDashboardEmail } from 'components/DashboardSendModal/types';
import { useSelector } from 'store/hooks';
import { useTranslation } from 'react-i18next';
import { UserInfoWithIdT, UserT } from 'business/definitions';
import { Autocomplete, capitalize, TextField } from '@mui/material';

type UserOptionT = Pick<UserT, 'id' | 'email'>;

const EmailSenderSelector = ({
    allUsers,
    disabled,
    scheduledEmail,
    updateEmail,
}: {
    allUsers: UserInfoWithIdT[];
    disabled: boolean;
    scheduledEmail: ScheduledDashboardEmail;
    updateEmail: (updates: Partial<ScheduledDashboardEmail>) => void;
}) => {
    const { t } = useTranslation();
    const isSupportUser = useSelector((state) => state.vision.isSupportUser);
    if (!isSupportUser) return null;

    const selected: UserOptionT = {
        id: scheduledEmail.senderId,
        email: scheduledEmail.sender,
    };

    const getUserOptions = (users: UserInfoWithIdT[]): UserOptionT[] =>
        users.map((user) => ({
            id: user.id,
            email: user.email,
        }));

    const handleChange = (value: UserOptionT | null) => {
        if (value === null) return;
        updateEmail({
            sender: value.email,
            senderId: value.id,
        });
    };

    return (
        <Autocomplete
            id="user"
            disabled={disabled}
            options={getUserOptions(allUsers)}
            getOptionLabel={(option: UserOptionT) => option.email}
            value={selected}
            freeSolo={false}
            onChange={(event, value) => handleChange(value)}
            noOptionsText={t('sendDashboard.senderMustBeMantyUser')}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={capitalize(t('sendDashboard.sender'))}
                />
            )}
        />
    );
};

export default EmailSenderSelector;
